<template>
    <div class="event-details__visualization">
        <SpinnerContainer
            v-show="isLoading"
            class="spinner-container--no-shadow"
        />
        <div
            v-show="!isLoading"
            :class="anchorClass"
        />
    </div>
</template>

<script>
    import { getConfig } from '@superbet-group/web.lib.config';
    import { IsoLanguageCode } from '@superbet-group/web.types';
    import {
        loadStyles,
        loadScript,
    } from '@superbet-group/web.lib.utilities';

    export default {
        name: 'MatchVisualization',
        inheritAttrs: false,
        props: {
            betRadarId: {
                type: String,
                default: undefined,
            },
        },
        data() {
            return {
                isLoading: true,
            };
        },
        created() {
            this.anchorClass = 'event-details__visualization__anchor';
        },
        async mounted() {
            const scriptUrl = `${window.location.origin}/static/js/initBetRadar.js`;
            const stylesUrl = `${window.location.origin}/static/css/betradar.min.css`;

            await loadScript(scriptUrl, 'betradar-widget');
            loadStyles(stylesUrl, 'betradar-widget-styles');

            // Localized override required only for BetRadar initialization
            let currentLanguage;

            if (getConfig().appLocale.languageCode === IsoLanguageCode.Serbian) {
                currentLanguage = 'srl';
            } else if (getConfig().appLocale.languageCode === IsoLanguageCode.Portuguese) {
                currentLanguage = 'br';
            } else {
                currentLanguage = getConfig().appLocale.languageCode;
            }

            window.SIR('changeLanguage', currentLanguage);
            this.init(this.betRadarId);
        },
        methods: {
            init(betRadarId) {
                const widgetOptions = {
                    layout: 'single',
                    scoreboard: 'disable',
                    momentum: 'disable',
                    tabsPosition: 'disable',
                    disableAds: 'true',
                    matchId: betRadarId,
                };
                window.SIR(
                    'addWidget',
                    `.${this.anchorClass}`,
                    'match.lmtPlus',
                    widgetOptions,
                    // Callback is called before the widget is visible
                    // on the screen, it makes a weird jump in the layout
                    () => setTimeout(() => {
                        this.isLoading = false;
                    }, 200),
                );
            },
        },
    };
</script>
